var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChervonRightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "02.-Icons\\uD83C\\uDF88",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-216.000000, -120.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Basic-/-Line-/-Chervon-/-Right",
    transform: "translate(216.000000, 120.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "10 6 8.59 7.41 13.17 12 8.59 16.59 10 18 16 12"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChervonRightIcon);
export default __webpack_public_path__ + "static/media/ChervonRightIcon.c5e1d517c01c428fde916fb8f1ed822f.svg";
export { ForwardRef as ReactComponent };